// extracted by mini-css-extract-plugin
module.exports = {"postTopicItem":"PostTopicItem_postTopicItem__1a890","active":"PostTopicItem_active__B987A"};